"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeSentry = void 0;

var tslib_1 = require("tslib");

var Sentry = tslib_1.__importStar(require("@sentry/node"));

var tracing_1 = require("@sentry/tracing");

var _1 = require(".");

var types_1 = require("./types");

var initializeSentry = function initializeSentry(_a) {
  var sentryDsn = _a.sentryDsn,
      sentryEnv = _a.sentryEnv,
      sentryRelease = _a.sentryRelease,
      _b = _a.customOptions,
      customOptions = _b === void 0 ? {} : _b;
  var integrations = [new tracing_1.Integrations.BrowserTracing({
    idleTimeout: 6000,
    finalTimeout: 0
  })];
  Sentry.init(tslib_1.__assign({
    dsn: sentryDsn,
    environment: sentryEnv,
    release: sentryRelease,
    integrations: integrations,
    tracesSampleRate: 0.2,
    beforeSend: function beforeSend(event) {
      // filter out events where sentryEnv is development
      if (sentryEnv === types_1.SentryEnv.Development) {
        console.error(event);
        return null;
      }

      return event;
    },
    ignoreErrors: _1.IGNORE_ERRORS_LIST
  }, customOptions));
};

exports.initializeSentry = initializeSentry;